import gql from 'graphql-tag';

const getServiceStatusQuery = gql`
  query {
    routes {
      name
      id
      routeCode
      ports {
        name
        order
        isFreight
        hideOnMap
      }
      routeStatuses {
        id
        title
        status
        subStatus
        updatedAtDateTime
      }
      location {
        name
      }
      status
      isFreight
      hideOnMap
      isStatusChangeUpcoming
    }
  }`;

const getRouteServiceStatusQuery = gql`
  query ($routeCode: String) {
    routes (where: {routeCode: { eq: $routeCode} }) {
      name
      id
      routeCode
      ports {
        name
        order
        isFreight
        hideOnMap
      }
      routeStatuses {
        id
        title
        status
        subStatus
        title
        startDateTime
        endDateTime
        detail
        nextReviewDateTime
        updatedAtDateTime
        disruptionReason
      }
      location {
        name
      }
      status
      isFreight
      hideOnMap
      isStatusChangeUpcoming
    }
  }`;

const getRoutesQuery = gql`
  query ($routeName: String)  {
    routes (where: {searchKey: { contains: $routeName} }) {
      name
      id
      routeCode
      ports {
        name
        order
        longitude
        latitude
        isFreight
        hideOnMap
      }
      routeStatuses {
        id
        title
        detail
        status
        subStatus
        startDateTime
        updatedAtDateTime
        nextReviewDateTime
        disruptionReason
      }
      location {
        name
      }
      status
      isFreight
      hideOnMap
      isStatusChangeUpcoming
    }
  }`;

const getRouteSuggestionQuery = gql`
  query ($routeName: String)  {
    routes (where: {searchKey: { contains: $routeName} })
  {
      name
      id
      ports {
        name
        order
      }
      location {
        name
      }
      status
    }
  }`;

export {
  getServiceStatusQuery,
  getRouteServiceStatusQuery,
  getRoutesQuery,
  getRouteSuggestionQuery,
};
